/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAttributeFilter } from '../models/CustomerAttributeFilter';
import type { HiringFunnelsResponse } from '../models/HiringFunnelsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MetricsFunnelsService {

    /**
     * Get hiring funnel data for universal dashboard metrics
     * Returns hiring data for WX metrics dashboard
     * @param xAccessToken
     * @param teamTasks
     * @param openingIds
     * @param locationIds
     * @param brandIds
     * @param positionIds
     * @param openingAttributes Filter funnels by customer attributes attached to the funnel itself. Encoded as opening_attributes[][attribute_key]=K&opening_attributes[][attribute_values][]=v.
     * @param positionAttributes Filter funnels by customer attributes attached to the funnel's position.
     * @param locationAttributes Filter funnels by customer attributes attached to the funnel's location.
     * @param query Free text search across funnel/location/position/brand names.
     * @param cursor
     * @param page
     * @param perPage
     * @returns HiringFunnelsResponse OK
     * @throws ApiError
     */
    public static getInternalApiWxMetricsFunnels(
        xAccessToken: string,
        teamTasks?: boolean,
        openingIds?: Array<string>,
        locationIds?: Array<string>,
        brandIds?: Array<string>,
        positionIds?: Array<string>,
        openingAttributes?: Array<CustomerAttributeFilter>,
        positionAttributes?: Array<CustomerAttributeFilter>,
        locationAttributes?: Array<CustomerAttributeFilter>,
        query?: string,
        cursor?: string,
        page?: number,
        perPage?: number,
    ): CancelablePromise<HiringFunnelsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/metrics/funnels',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            query: {
                'team_tasks': teamTasks,
                'opening_ids[]': openingIds,
                'location_ids[]': locationIds,
                'brand_ids[]': brandIds,
                'position_ids[]': positionIds,
                'opening_attributes[]': openingAttributes,
                'position_attributes[]': positionAttributes,
                'location_attributes[]': locationAttributes,
                'query': query,
                'cursor': cursor,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}